<script lang="ts">
	import type { Recipe } from "./recipe.types";
	import { grocery_list } from "./recipe_stores";

	import { onMount } from "svelte";
	import { crossfade, fly, fade } from "svelte/transition";
	import { flip } from "svelte/animate";
	import { quintOut } from "svelte/easing";
	import { get_recipes } from "../tastummy";
	import RecipeView from "./RecipeView.svelte";
	import GroceryList from "./GroceryList.svelte";
	import Popup from "../general/Popup.svelte";
	import Loading from "../general/Loading.svelte";

	const [send, receive] = crossfade({
		duration: (d) => Math.sqrt(d * 200),
		fallback(node, params) {
			const style = getComputedStyle(node);
			const transform = style.transform === "none" ? "" : style.transform;
			return {
				duration: 600,
				easing: quintOut,
				css: (t) => `
					transform: ${transform} scale(${t});
				`,
			};
		},
	});
	let loading = false;
	let display_groceries: boolean = false;
	let unselected_recipes: Recipe[] = [];
	let selected_recipes: Recipe[] = [];
	function select_recipe(rec: Recipe) {
		selected_recipes = [...selected_recipes, rec];
		unselected_recipes = unselected_recipes.filter(
			(cmp_rec) => rec !== cmp_rec
		);
		$grocery_list = selected_recipes;
	}
	function unselect_recipe(rec: Recipe) {
		unselected_recipes = [...unselected_recipes, rec];
		selected_recipes = selected_recipes.filter(
			(cmp_rec) => rec !== cmp_rec
		);
		$grocery_list = selected_recipes;
	}
	onMount(async () => {
		loading = true;
		let r = await get_recipes();
		loading = false;
		unselected_recipes = r.data;
	});
</script>

<h1>Your Recipes</h1>
<p>Select The Recipes You Would Like To Prepare</p>
<button class="display-button" on:click={() => (display_groceries = true)}
	>+</button
>
{#if loading}
	<Loading />
{/if}
<div class="selector-area">
	<div class="recipe-section">
		{#each unselected_recipes as recipe (recipe.id)}
			<div
				in:receive={{ key: recipe.title }}
				out:send={{ key: recipe.title }}
				animate:flip
			>
				<RecipeView {recipe} on:clicked={() => select_recipe(recipe)} />
			</div>
		{/each}
	</div>
	{#if selected_recipes.length > 0}
		<div
			in:fly={{ x: 200, duration: 400 }}
			out:fade={{ duration: 1000 }}
			class="cart"
		>
			{#each selected_recipes as recipe (recipe.id)}
				<div
					in:receive={{ key: recipe.title }}
					out:send={{ key: recipe.title }}
					animate:flip
				>
					<RecipeView
						{recipe}
						simple={true}
						on:clicked={() => unselect_recipe(recipe)}
					/>
				</div>
			{/each}
		</div>
	{/if}
</div>

<Popup bind:visible={display_groceries}>
	<GroceryList />
</Popup>

<style>
	.selector-area {
		display: grid;
		grid-template-columns: 3fr 1fr;
		width: 100%;
	}
	.recipe-section {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
	.cart {
		max-height: 20rem;
		outline: 2px solid gray;
		overflow: auto;
		background-color: var(--background-2);
	}
	.display-button {
		position: fixed;
		bottom: 10%;
		right: 10%;
		z-index: 1;
	}
	p {
		font-size: 2em;
	}
	@media (min-width: 640px) {
		.recipe-section {
			grid-template-columns: repeat(3, 1fr);
		}
	}
	@media (min-height: 900px) {
		.cart {
			max-height: 50rem;
		}
	}
</style>
